import { render, staticRenderFns } from "./BufferKey.vue?vue&type=template&id=4f21f7f4"
import script from "./BufferKey.vue?vue&type=script&lang=js"
export * from "./BufferKey.vue?vue&type=script&lang=js"
import style0 from "./BufferKey.vue?vue&type=style&index=0&id=4f21f7f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports